import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-header-selector',
	templateUrl: 'header-selector.component.html',
	standalone: false,
})
export class HeaderSelectorComponent {
	@Input() set headerConfiguration(headerEnabled: boolean) {
		this.firstPageHeader = headerEnabled;
	}

	@Output() headerConfigurationChange = new EventEmitter<boolean>();

	public firstPageHeader = false;

	onFirstPageHeaderChange(value: boolean) {
		this.firstPageHeader = value;
		this.headerConfigurationChange.emit(value);
	}
}
